import React, {  Component } from 'react';
import { connect } from 'react-redux';

import moment from 'moment';

/* Actions */
import {
	getMonogramData,
	saveMonogramData
} from '../../../redux/actions';


class Monogram extends Component {

	constructor(props) {
		super(props);
		this.state = {
			errorMessage: '',
			monogramData: null,
			monogramBase: ['1.00%','2.00%','3.00%','4.00%','5.00%']
		}
	}

	componentDidMount() {
		const self = this;
		const { monogramData } = self.props.state.resources;
		let dataByAccountNumber = monogramData && monogramData.find(item => item.accountNumber === self.props.getSelectedAccountNumber());
		dataByAccountNumber = dataByAccountNumber && dataByAccountNumber.data;
		if(!dataByAccountNumber) {
			self.props.getMonogramData("requestType=mvrt&accountNumber="+self.props.getSelectedAccountNumber()+"&year=2025", response => {
				if(!response.status) {
					self.setState({
						errorMessage: response.responseMessage
					});
				} else {
					self.props.saveMonogramData({
						accountNumber: self.props.getSelectedAccountNumber(),
						data: response
					});
					let data = JSON.parse(JSON.stringify(response.responseObject));
					data.mvrMatrix = window.convertToArrayOfObject(data.mvrMatrix, 'groupBy');
					self.setState({
						monogramData: data
					});
				}
			});
		} else {
			const data = JSON.parse(JSON.stringify(dataByAccountNumber.responseObject));
			data.mvrMatrix = window.convertToArrayOfObject(data.mvrMatrix, 'groupBy');
			self.setState({
				monogramData: data
			});
		}
		const { user } = this.props.state;
        if(user.selectedAccount && user.selectedPriceSource) {
            this.setState({
                showSelectAccountAndPriceSourceOverlayDialog: false
            });
        } else {
            this.setState({
                showSelectAccountAndPriceSourceOverlayDialog: true
            });
        }
	}

	checkIfHighlight(mnMatSelect, valueToCompare, index) {
		if(mnMatSelect) {
			if((index === 0 && mnMatSelect.split("_")[index] === valueToCompare) || (index === 1 && mnMatSelect === valueToCompare))  {
				return 'highlight-cell';
			}
		}
		return null;
	}

    render() {
		const { monogramData } = this.state;
		const self = this;
		const { selectedAccount } = self.props.state.user;
		if(monogramData) {
			var sortedArray = monogramData.mvrMatrix.sort(function(a,b){
				return a.list >b.list?1:a.list <b.list?-1:0
		 	});
		}
		const priorYearGSB = monogramData && Math.round(monogramData.priorYearGSB);
        const priorYearGSB10Percent = monogramData && Math.round(monogramData.priorYearGSB + (monogramData.priorYearGSB) * 0.10);
        const priorYearGSB20Percent = monogramData && Math.round(monogramData.priorYearGSB + (monogramData.priorYearGSB) * 0.20);
        const priorYearGSB30Percent = monogramData && Math.round(monogramData.priorYearGSB + (monogramData.priorYearGSB) * 0.30);
        return (
			<div>
				<p className="red bold">{this.state.errorMessage}</p>
				{monogramData && monogramData.dataAvailable && <p style={{float: 'right', display: 'inline-block'}}>
					<a href="" onClick={this.props.handlePrint} className="withIcon withPrintIcon noUnderline uppercase bold">Print</a>
				</p>}
				<h1 className="pageTitle" style={{margin: '2em 0 1em'}}>Monogram Volume Rebate Tracker</h1>
				{monogramData && !monogramData.dataAvailable && <p>No Monogram Volume Rebate available for this account.</p>}
				{monogramData && monogramData.dataAvailable && <div>
					<b>Account:</b> {selectedAccount && selectedAccount.ACCOUNTNUMBER}&nbsp;<b>-</b>&nbsp;{selectedAccount && selectedAccount.ACCOUNTDESCRIPTION}<br />
			        <h2>Today&#39;s Date: {moment().format('MMMM DD, YYYY')}</h2>
			        <p className="orange" style={{marginTop: '-14px'}}>(Billing Date: {monogramData.maxBillingDate})</p>
			        <p style={{marginBottom: 20}}>The information in this screen is provided to those members that participate in the Monogram VR program. Information is updated nightly.</p>
			        <h2>Monogram VR Baseline &amp; Growth Targets</h2>
					<table cellPadding={0} cellSpacing={0} className="pvrTableOne push">
						<tbody>
							<tr>
								<th className="txt-ctr">Prior Year<br />Year-End Eligible<br />Count / Target <span style={{fontWeight: 'normal'}}>(Baseline)</span></th>
								<th className="txt-ctr">0% Growth<br />Target</th>
								<th className="txt-ctr">10% Growth<br />Target</th>
								<th className="txt-ctr">20% Growth<br />Target</th>
								<th className="txt-ctr">30% Growth<br />Target</th>
							</tr>
							<tr>
								<td className="txt-ctr"><b>{this.props.formatMoney(priorYearGSB.toFixed(0), 0, ".", ",", true, "$")}</b></td>
								<td className="txt-ctr">{this.props.formatMoney(priorYearGSB.toFixed(0), 0, ".", ",", true, "$")}</td>
								<td className="txt-ctr">{this.props.formatMoney(priorYearGSB10Percent, 0, ".", ",", true, "$")}</td>
								<td className="txt-ctr">{this.props.formatMoney(priorYearGSB20Percent, 0, ".", ",", true, "$")}</td>
								<td className="txt-ctr">{this.props.formatMoney(priorYearGSB30Percent, 0, ".", ",", true, "$")}</td>
							</tr>
						</tbody>
					</table>
			        <h2>Current Monogram VR YTD As of {monogramData.maxBillingDate}</h2>
			        <div style={{width: 300, float: 'left', marginRight: 36}}>
						<table className="dataTable" width="100%">
							<caption className="txt-ctr">YTD Eligible Count / Target</caption>
							<thead>
								<tr>
									<th className="txt-ctr">GSB</th>
									<th className="txt-ctr">Current V%</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td className="txt-ctr" style={{backgroundColor: '#fff'}}>{this.props.formatMoney(parseFloat(monogramData.targetGSB).toFixed(0), 0, ".", ",", true, "$")}</td>
									<td className="txt-ctr" style={{backgroundColor: '#fff'}}>{monogramData.currentVPercentage}%</td>
								</tr>
							</tbody>
						</table>
			        </div>
			        <div style={{width: 400, float: 'left', marginRight: 36}}>
						<table className="dataTable" width="100%">
							<caption className="txt-ctr">YTD Eligible Purchases For Payout</caption>
							<thead>
								<tr>
									<th className="txt-ctr">GSB</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td className="txt-ctr" style={{backgroundColor: '#fff'}}>{this.props.formatMoney(parseFloat(monogramData.gsbPayout).toFixed(0), 0, ".", ",", true, "$")}</td>
								</tr>
							</tbody>
						</table>
			        </div>
			        <div style={{width: 205, float: 'left'}}>
						<table className="dataTable" width="100%">
							<caption className="txt-ctr">YTD</caption>
							<thead>
								<tr>
									<th className="txt-ctr">Monogram VR Estimate</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td className="txt-ctr" style={{backgroundColor: '#fff'}}>{this.props.formatMoney(monogramData.mvrEstimate, 0, ".", ",", true, "$")}</td>
								</tr>
								<tr>
									<td className="txt-ctr" colSpan={2} style={{backgroundColor: '#eee', fontSize: '0.8em'}}>Estimate only.</td>
								</tr>
							</tbody>
						</table>
			        </div>
			        <div className="clear" />
			        <h2>Monogram VR Matrix</h2>
			        <table className="dataTable" width="100%">
						<thead>
							<tr className="captionAboveTable captionLikeStyle">
								<th>Monogram VR Target Retail Purchases <b>($GSB)</b></th>
								<th className="txt-ctr">Flat</th>
								<th className="txt-ctr">+10% Growth</th>
								<th className="txt-ctr">+20% Growth</th>
								<th className="txt-ctr">+30% Growth</th>
							</tr>
						</thead>
						<tbody>
							{sortedArray.map((item, index) => {
								return <tr key={index}>
									<td><span className={this.checkIfHighlight(monogramData.mnMatSelect, item.key, 0)}>${item.key.replace("M", "k").replace("kM", "M")}</span></td>
									<td className="txt-ctr"><span className={this.checkIfHighlight(monogramData.mnMatSelect, item.key + '_F', 1)}>{item.list[1] ? `${parseFloat(item.list[1]).toFixed(2)} %` : null}</span></td>
									<td className="txt-ctr"><span className={this.checkIfHighlight(monogramData.mnMatSelect, item.key + '_10', 1)}>{item.list[2] ? `${parseFloat(item.list[2]).toFixed(2)} %` : null}</span></td>
									<td className="txt-ctr"><span className={this.checkIfHighlight(monogramData.mnMatSelect, item.key + '_20', 1)}>{item.list[3] ? `${parseFloat(item.list[3]).toFixed(2)} %` : null}</span></td>
									<td className="txt-ctr"><span className={this.checkIfHighlight(monogramData.mnMatSelect, item.key + '_30', 1)}>{item.list[4] ? `${parseFloat(item.list[4]).toFixed(2)} %` : null}</span></td>
								</tr>
							})}
						</tbody>
			        </table>
					<p className="red">*Exclusions from payment: Quotes, As-is, Obsolete, Superseded and Home Ownership</p>
				</div>}
			</div>
        );
    }
}
const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	getMonogramData: (queryString, callback) => dispatch(getMonogramData(queryString, callback)),
	saveMonogramData: (data) => dispatch(saveMonogramData(data)),
});

Monogram = connect(mapStateToProps, mapDispatchToProps)(Monogram);
export default Monogram;


// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Monogram/index.js